import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Summary from "@/pages/summary/page";
import Archive from "@/pages/archive/page";
import PostDetail from "@/pages/post/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "summary", element: <Summary /> },
      { path: "archive", element: <Archive /> },
      { path: "post/:id", element: <PostDetail /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;